import store, { persistor } from './storeSetup';

export { persistor };
export default store;
